import { gql } from '@apollo/client';

export const GET_RMA_DETAILS = gql`
  query RmaDetails($rma_id: Int!) {
    rmaDetails(rma_id: $rma_id) {
      additional_info
      expedition_number
      order_id
      order_number
      refunded_amount
      resolution_type
      status {
        code
      }
      rma_id
      creation_date


      products {
        product_id
        product_image
        product_name
        product_price
        product_sku
        qty
        reason
        attributes {
          code
          value
        }
      }
    }
  }
`;
